import { getStandardDialogTheme } from "./utils";
import { UserTemplatesDialogProps } from "./type";
import { ContinueButton } from "../../Custom/Buttons";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  ThemeProvider,
} from "@mui/material";

import {
  ActionsContainer,
  HeaderContainer,
  PopupCloseIconComponent,
} from "./styled";

export default function UserTemplatesDialog({
  open,
  closeHandler,
  submitHandler,
  renderContent,
}: UserTemplatesDialogProps) {
  return (
    <ThemeProvider theme={getStandardDialogTheme()}>
      <Dialog
        fullWidth
        open={open}
        maxWidth="md"
        scroll="paper"
        sx={{ "& .MuiDialog-paper": { height: "95vh" } }}
      >
        <DialogTitle>
          <HeaderContainer>
            User Templates
            <IconButton onClick={closeHandler}>
              <PopupCloseIconComponent />
            </IconButton>
          </HeaderContainer>
        </DialogTitle>
        <DialogContent>{renderContent()}</DialogContent>
        <DialogActions>
          <ActionsContainer>
            <ContinueButton onClick={submitHandler} />
          </ActionsContainer>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
}
